// relayed-source.ts read off this client's stores: the one call the chat row and the search results make.
import type { Message } from "$lib/types.js";
import { PROVIDER_LABELS } from "$lib/agent-display.js";
import { workspaceState } from "$lib/state/app.svelte.js";
import { cyboState } from "$lib/plugins/agents/state.svelte.js";
import { messageEdgeById } from "$lib/plugins/agents/message-edges.svelte.js";
import { sessionOwnName } from "$lib/state/session-alias.svelte.js";
import { relayedSource, type RelayedSource } from "./relayed-source.js";

/** Who sent this message for its person, or null when the person wrote it themselves. */
export function relayedRowOf(message: Pick<Message, "card">): RelayedSource | null {
  const card = message.card;
  if (card?.kind !== "handoff") return null; // null: an ordinary message
  return relayedSource(card, {
    agents: workspaceState.agents ?? [],
    cybos: cyboState.list ?? [],
    ownName: sessionOwnName,
    edge: messageEdgeById(card.handoffId),
    providerLabel: (provider) => PROVIDER_LABELS[provider],
  });
}
